module.exports = __webpack_public_path__ + "img/2595@2x.fee6a378.png";